
import { Component, Inject, Vue } from 'vue-property-decorator';
import GeneralScaffold from '@/components/GeneralScaffold.vue';
import FormModelDisplay from '@/components/FormModelDisplay.vue';
import EmbeddedForm from '@/util/form/EmbeddedForm';
import EmployeeRepository from '@/repositories/employees/EmployeeRepository';
import EmployeeTranslationRepository from '@/repositories/employees/EmployeeTranslationRepository';

@Component({
    components: {
        GeneralScaffold,
        FormModelDisplay,
    },
})
export default class EmployeeFormScreen extends Vue {
    @Inject()
    private readonly employeeRepository!: EmployeeRepository;

    @Inject()
    private readonly employeeTranslationRepository!: EmployeeTranslationRepository;

    public get embeds(): EmbeddedForm[] {
        return [
            {
                relationship: 'translations',
                parentRefKey: 'employeeId',
                i18nGroup: 'employee-translation',
                entityRepository: this.employeeTranslationRepository,
                columns: ['lang', 'title', 'subtitle'],
            },
            {
                relationship: 'order',
                parentRefKey: 'employeeId',
                i18nGroup: 'employee',
                entityRepository: this.employeeRepository,
                columns: ['name'],
            },
        ];
    }
}
